import {Question} from './question.model';
import {Answer} from './answer.model';

export class QuestionWithAnswer {
  public answer: Answer;
  public question: Question;

  constructor(answer: Answer, question: Question) {
    this.answer = answer;
    this.question = question;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/question-with-answer.model.ts